import { render, staticRenderFns } from "./AddNewPayService.vue?vue&type=template&id=3b18cb1a&scoped=true&"
import script from "./AddNewPayService.vue?vue&type=script&lang=ts&"
export * from "./AddNewPayService.vue?vue&type=script&lang=ts&"
import style0 from "./AddNewPayService.vue?vue&type=style&index=0&id=3b18cb1a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b18cb1a",
  null
  
)

export default component.exports